var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"grow"}},[(!!_vm.selected)?_c('button',{staticClass:"floating-button",class:{ 'floating-button__editing': !!_vm.editing },style:({ background: _vm.gradientColor }),on:{"click":_vm.toggleEditing}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }